import { MuiAccordion } from "./accordion.modifier";
import { MuiButton } from "./button.modifier";
import { MuiDialog } from "./dialog.modifier";
import { MuiIconButton } from "./iconButton.modifier";
import { MuiFormLabel } from "./formLabel.modifier";
import { MuiPaper } from "./paper.modifier";
import { MuiTextField } from "./textField.modifier";
import { MuiTooltip } from "./tooltip.modifier";
import { MuiCard } from "./card.modifier";
import { MuiDataGrid, MuiTablePagination } from "./table.modifier";
import { MuiTabs } from "./tabs.modifier";
import { MuiSelect } from "./select.modifier";
import { MuiDivider } from "./divider.modifier";

export const components = {
  MuiAccordion,
  MuiButton,
  MuiCard,
  MuiDialog,
  MuiIconButton,
  MuiFormLabel,
  MuiPaper,
  MuiTextField,
  MuiTooltip,
  MuiTablePagination,
  MuiDataGrid,
  MuiTabs,
  MuiSelect,
  MuiDivider,
};
